/** @format */
import { scrollIntoViewOnPageChangeModule } from '../scroll/scrollIntoViewOnPageChange.directive';
import { PaginationComponent } from './pagination.component';
import sisuPaginationWithContentTpl from './sisuPaginationWithContent.tpl.html';

export const sisuPaginationWithContentModule = 'sis-components.pagination.content';

(function () {
    /**
     * Use Angular component PaginationComponent instead.
     *
     * @deprecated
     */
    angular
        .module(sisuPaginationWithContentModule, [PaginationComponent.downgrade.moduleName, scrollIntoViewOnPageChangeModule])
        .component('sisuPaginationWithContent', {
            transclude: true,
            template: sisuPaginationWithContentTpl,
            controller: sisuPaginationController,
            bindings: {
                initPage: '<',
                currentPageData: '<',
                itemsPerPage: '<',
                maxSize: '<',
                pageContentSearchFunction: '<',
                currentPageContentCallback: '<',
                paginationOver: '<',
                paginationUnder: '<',
                scrollIntoViewElement: '<',
            },
        });

    /**
     * Default page navigation is over the content but it can be over or under or both.
     * Relies heavily on fi.helsinki.otm.common.model.SearchResult.
     * Use currentPageData to manually fire page change from parent component.
     */
    function sisuPaginationController() {
        var ctrl = this;
        ctrl.loaded = false;

        ctrl.$onInit = function () {
            ctrl.itemsTotalCount = 0;
            ctrl.currentPage = ctrl.initPage || 1;
            ctrl.maxSize = ctrl.maxSize || 5;
            if (!ctrl.paginationOver && !ctrl.paginationUnder) {
                ctrl.paginationOver = true;
            }

            ctrl.setOnChangeFunctions();
            ctrl.onPageChange(ctrl.currentPage);
        };

        ctrl.$onChanges = function (changesObj) {
            var currentPage = _.get(changesObj, 'currentPageData.currentValue.page');
            if (currentPage) {
                ctrl.currentPage = currentPage;
                ctrl.onPageChange(ctrl.currentPage);
            }
        };

        ctrl.onPageChange = function (page) {
            ctrl.currentPage = page;
            var start = ctrl.itemsPerPage * (page - 1);
            ctrl.pageContentSearchFunction(ctrl.itemsPerPage, start)
                .then(function (response) {
                    ctrl.itemsTotalCount = response.total;
                    ctrl.loaded = true;
                    return response;
                })
                .then(ctrl.currentPageContentCallback);
        };

        ctrl.setOnChangeFunctions = function () {
            if (ctrl.paginationOver) {
                ctrl.onPageChangeOver = realOnChange;
                ctrl.onPageChangeUnder = dummyOnChange;
            } else {
                ctrl.onPageChangeOver = dummyOnChange;
                ctrl.onPageChangeUnder = realOnChange;
            }
        };

        function realOnChange(page) {
            ctrl.onPageChange(page);
        }

        function dummyOnChange() {
            //Empty
        }

        ctrl.showPagination = function () {
            return ctrl.loaded && ctrl.itemsTotalCount > ctrl.itemsPerPage;
        };
    }
})();
